import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { authApi } from "./auth/api";
import { recoveryApi } from "./recovery/api";
import { gamesApi } from "./game/api";
import { paymentApi } from "./payment/api";
import { userApi } from "./user/api";
import { profileApi } from "./profile/api";
import { transactionsApi } from "./transaction/api";
import { bannerApi } from "./banner/api";
import { geoApi } from "./geo/api";
import { referralApi } from "./referral/api";
import { rtkQueryErrorLogger } from "./middleware/ErrorHandlingMiddleware";
import authReducer from "./auth/slice";
import notificationReducer from "./notification/slice";
import gameReducer from "./game/slice";
import paymentReducer from "./payment/slice";
import userReducer from "./user/slice";
import transactionReducer from "./transaction/slice";
import wheelReducer from "./landing/wheels/slice";
import profileReducer from "./profile/slice";
import recoveryReducer from "./recovery/slice";
import bannerReducer from "./banner/slice";
import geoReducer from "./geo/slice";
import referralReducer from "./referral/slice";

const rootReducer = combineReducers({
  authReducer,
  gameReducer,
  notificationReducer,
  paymentReducer,
  transactionReducer,
  userReducer,
  wheelReducer,
  profileReducer,
  recoveryReducer,
  bannerReducer,
  geoReducer,
  referralReducer,
  [authApi.reducerPath]: authApi.reducer,
  [gamesApi.reducerPath]: gamesApi.reducer,
  [paymentApi.reducerPath]: paymentApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [profileApi.reducerPath]: profileApi.reducer,
  [transactionsApi.reducerPath]: transactionsApi.reducer,
  [recoveryApi.reducerPath]: recoveryApi.reducer,
  [bannerApi.reducerPath]: bannerApi.reducer,
  [geoApi.reducerPath]: geoApi.reducer,
  [referralApi.reducerPath]: referralApi.reducer,
});

const setupStore = () => {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }).concat(
        rtkQueryErrorLogger,
        authApi.middleware,
        gamesApi.middleware,
        userApi.middleware,
        profileApi.middleware,
        transactionsApi.middleware,
        paymentApi.middleware,
        recoveryApi.middleware,
        bannerApi.middleware,
        geoApi.middleware,
        referralApi.middleware,
      ),
  });
};

export const store = setupStore();

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore["dispatch"];
